export { PersonalPage } from './personal-page';
export { personalPageI18n } from './personal-page.i18n';